<template>
  <a-tree-select
    allowClear
    labelInValue
    style="width: 100%"
    :disabled="disabled"
    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
    :placeholder="placeholder"
    :treeDefaultExpandAll="autoExpand"
    :loadData="asyncLoadTreeData"
    :value="treeValue"
    :treeData="treeData"
    :multiple="multiple"
    :treeCheckable="treeCheckable"
    :getPopupContainer="getPopupContainer"
    @change="onChange"
  >
  </a-tree-select>
</template>
<script>
import { getAction } from "@/api/manage";

export default {
  name: "JCategorySelect",
  props: {
    value: {
      type: String,
      required: false,
    },
    //返回值还是ID
    returnValue: {
      type: Boolean,
      default: false,
      require: false,
    },
    placeholder: {
      type: String,
      default: "请选择",
      required: false,
    },
    getPopupContainer:{
      type: Function,
      required:false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    condition: {
      type: String,
      default: "",
      required: false,
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: false,
    },
    //显示勾选框
    treeCheckable: {
      type: Boolean,
      default: false,
    },
    pid: {
      type: String,
      default: "",
      required: false,
    },
    pcode: {
      type: String,
      default: "",
      required: false,
    },
    //只能选择叶子节点
    onlyLeaf: {
      type: Boolean,
      default: false,
    },
    //同级别互斥
    mutex: {
      type: Boolean,
      default: false,
    },
    //自动展开节点
    autoExpand: {
      type: Boolean,
      default: true,
    },
    //限制ID，不限制未null，多个使用英文逗号分割
    categoryLimit :{
      type: String,
      default: null
    },
    // 限制ID的方式： 禁用disabled、隐藏hide
    categoryLimitStyle: {
      type: String,
      default: 'disabled'
    },
    // 显示全部层级路径
    showFullPath: {
      type: Boolean,
      default: false
    },
    // 过滤没有子节点的父级节点
    hideNoneChildrenNode: {
      type: Boolean,
      default: false
    },
    dropdownStyle: {
      type: Object,
      default: ()=>{return { maxHeight: "400px", overflow: "auto" }},
    },
  },
  data() {
    return {
      treeValue: "",
      treeData: [],
      url: "/sys/category/loadTreeData",
      view: "/sys/category/loadDictItem",
      tableName: "",
      text: "",
      code: "",
    };
  },
  watch: {
    value() {
      this.loadItemByCode();
    },
    pcode() {
      this.loadRoot();
    },
    pid() {
      this.loadRoot();
    },
    categoryLimit() {
      this.loadRoot();
    }
  },
  created() {
    this.validateProp().then(() => {
      this.loadRoot();
      this.loadItemByCode();
    });
  },
  methods: {
    /**加载一级节点 */
    loadRoot() {
      if (!this.pcode && !this.pid) {
        return;
      }
      let param = {
        pid: this.pid,
        pcode: this.pcode,
        condition: this.condition,
        async: !this.autoExpand,
      };
      getAction(this.url, param).then((res) => {
        if (res.success && res.result) {
          
          this.processTreeData(res.result);
          res.result = this.filterTreeNode(res.result)
          if(this.hideNoneChildrenNode){
            res.result = this.filterNoneChildrenTreeNode(res.result)
          }
          this.treeData = [...res.result];
          console.log("树一级节点查询结果");
          console.log(this.treeData);
        } else {
          console.log("树一级节点查询结果-else", res);
        }
      });
    },

    processTreeData(tree) {
      for (let i in tree) {
        let t= tree[i]
        t.customValue = t.value
        // t.value = t.key;
        t.value =this.returnValue?t.value:t.key
        if (t.leaf == false) {
          if (this.onlyLeaf) {
            t.disabled = true;
          }
          t.isLeaf = false;
        } else if (t.leaf == true) {
          t.isLeaf = true;
        }
        if(this.categoryLimit != null && !this.categoryLimit.includes(t.key)){
          if(this.categoryLimitStyle == 'hide' && t.leaf){
            t.hide = true
          }else if(this.categoryLimitStyle == 'disabled'){
            t.disabled = true;
          }
        }
        if (!t.leaf) {
          this.processTreeData(t.children);
        }
      }
    },
    // 过滤标记隐藏的节点
    filterTreeNode(list){
      return list.filter(i=>{
        if(i.children){
          i.children = this.filterTreeNode(i.children)
        }
        return i.hide !== true
      })
    },
    // 过滤没有子节点的父级节点
    filterNoneChildrenTreeNode(list){
      console.log(list);
      return list.filter(i=>{
        if(!i.isLeaf && (i.children==null||i.children.length==0)){
          return false
        }
        return true
      })
    },
    /** 数据回显*/
    loadItemByCode() {
      if (!this.value || this.value == "0") {
        this.treeValue = [];
      } else {
        let param = {
          ids: this.value,
          pcode: !this.pcode ? "0" : this.pcode,
        };
        getAction(this.view, param).then((res) => {
          if (res.success) {
            let values = this.value.split(",");
            this.treeValue = res.result.map((item, index) => ({
              key: values[index],
              value: values[index],
              label: this.showFullPath?item.path:item.name,
              customValue: item.value
            }));
            console.log("树回显查询结果");
            console.log(this.treeValue);
            this.onLoadTriggleChange(res.result[0]);
          }
        });
      }
    },
    onLoadTriggleChange(item) {
      //TODO 这里只会回显一个选项？
      //只有单选才会触发
      //if (!this.multiple && this.loadTriggleChange) {
        this.backValue(this.value, item, this.treeValue);
      //}
    },
    backValue(value, label, treeData) {
      const filterData = (td, key, newArr = []) => {
        for(let d in td){
          if(key.includes(td[d].key)){
            newArr.push(td[d])
          }
          if(td[d].children){
            filterData(td[d].children, key, newArr)
          }
        }
      }
      let data = []
      filterData(treeData, value, data)
      this.$emit("change", value, label, data);
    },
    asyncLoadTreeData(treeNode) {
      return new Promise((resolve) => {
        if (this.autoExpand) {
          resolve();
          return;
        }
        if (treeNode.$vnode.children) {
          resolve();
          return;
        }
        let pid = treeNode.$vnode.key;
        let param = {
          pid: pid,
          condition: this.condition,
        };
        getAction(this.url, param).then((res) => {
          if (res.success) {
            for (let i of res.result) {
              i.customValue = i.value
              // i.value = i.key;
               i.value = this.returnValue?i.value:i.key
              if (i.leaf == false) {
                i.isLeaf = false;
                if (this.onlyLeaf) {
                  i.disabled = true;
                }
              } else if (i.leaf == true) {
                i.isLeaf = true;
              }
            }
            this.addChildren(pid, res.result, this.treeData);
            this.treeData = [...this.treeData];
          }
          resolve();
        });
      });
    },
    addChildren(pid, children, treeArray) {
      if (treeArray && treeArray.length > 0) {
        for (let item of treeArray) {
          if (item.key == pid) {
            if (!children || children.length == 0) {
              item.isLeaf = true;
            } else {
              item.children = children;
            }
            break;
          } else {
            this.addChildren(pid, children, item.children);
          }
        }
      }
    },

    onChange(value, label, extra) {
      if (!value) {
        this.$emit("change", "");
        this.treeValue = "";
      } else if (Array.isArray(value)) {
        let labels = [];
        let values = value.map((item) => {
          labels.push(item.label);
          return item.value;
        });
        this.backValue(values.join(","), labels, this.treeData);
        this.treeValue = value;

        //同级别下的数据互斥
        const diabledOther = (treeData)=>{
            let selected = null
            for(let i in treeData){
              if(values.includes(treeData[i].value)){
                selected = treeData[i].value
              }
            }
            for(let i in treeData){
              if(this.onlyLeaf && treeData[i].leaf == false){continue}
              if(selected == null || selected === treeData[i].value){
                treeData[i].disabled = false
              }else{
                treeData[i].disabled = true
              }
              if(this.categoryLimit != null && !this.categoryLimit.includes(treeData[i].key)){
                treeData[i].disabled = true;
              }
            }
            for(let d in treeData){
              if(treeData[d].children){
                diabledOther(treeData[d].children)
              }
            }
        }
        if(this.mutex){
          diabledOther(this.treeData)
        }
      } else {
        this.backValue(value.value, value.label, this.treeData);
        this.treeValue = value;
      }
    },
    getCurrTreeData() {
      return this.treeData;
    },
    validateProp() {
      let mycondition = this.condition;
      return new Promise((resolve, reject) => {
        if (!mycondition) {
          resolve();
        } else {
          try {
            let test = JSON.parse(mycondition);
            if (typeof test == "object" && test) {
              resolve();
            } else {
              this.$message.error(
                "组件JTreeSelect-condition传值有误，需要一个json字符串!"
              );
              reject();
            }
          } catch (e) {
            this.$message.error(
              "组件JTreeSelect-condition传值有误，需要一个json字符串!"
            );
            reject();
          }
        }
      });
    },
  },
  //2.2新增 在组件内定义 指定父组件调用时候的传值属性和事件类型 这个牛逼
  model: {
    prop: "value",
    event: "change",
  },
};
</script>
